import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, Text, Tooltip } from "components";
import { PlusIcon } from "./icons";
import { CREATE_CHOOSER, CREATE_ENTRIES } from "./createEntries";

/**
 * Always-first grid tile (PRD §8.2): dashed card. Clicking the tile opens the
 * create chooser (/create); Blank + AI generate are explicit shortcuts.
 * Pre-crafted / Import CSV are §10 placeholders.
 */
const NewGameTile = () => {
  const navigate = useNavigate();
  const stop = (e) => e.stopPropagation();
  const go = (route) => (e) => {
    e.stopPropagation();
    navigate(route);
  };

  return (
    <Card
      dashed
      padding="lg"
      interactive
      className="da-newtile"
      onClick={() => navigate(CREATE_CHOOSER)}
    >
      <div className="da-newtile-plus">
        <PlusIcon size={20} />
      </div>
      <Text variant="h3" className="da-newtile-title">
        Create a new game
      </Text>
      <Text variant="caption" tone="muted" className="da-newtile-sub">
        Start from scratch or let AI draft a board
      </Text>
      <div className="da-newtile-options">
        {CREATE_ENTRIES.map(({ key, label, Icon, route, soon }) =>
          soon ? (
            <Tooltip key={key} title={soon}>
              <span className="da-newtile-soon" onClick={stop}>
                <Icon size={12} /> {label}
              </span>
            </Tooltip>
          ) : (
            <button key={key} type="button" onClick={go(route)}>
              <Icon size={12} /> {label}
            </button>
          )
        )}
      </div>
    </Card>
  );
};

export default NewGameTile;
